import { useActionSheet } from '@expo/react-native-action-sheet';
import { useCallback } from 'react';
import { Platform } from 'react-native';
export function useInteractionsSheet() {
    const { showActionSheetWithOptions } = useActionSheet();
    const showInteractionsSheet = useCallback(({ interactions, cancelKey = 'cancel' }) => {
        const options = interactions.map(interaction => interaction.text || interaction.action);
        const cancelButtonIndex = interactions.findIndex(x => x.action === cancelKey);
        showActionSheetWithOptions({
            useModal: true,
            cancelButtonIndex,
            options,
            containerStyle: Platform.select({
                default: {
                    maxHeight: 200
                },
                web: {
                    maxHeight: 500,
                    width: '100%',
                    maxWidth: 500,
                    alignSelf: 'center'
                }
            })
        }, (buttonIndex) => {
            var _a, _b;
            if (buttonIndex === undefined) {
                return;
            }
            (_b = (_a = interactions[buttonIndex]) === null || _a === void 0 ? void 0 : _a.onPress) === null || _b === void 0 ? void 0 : _b.call(_a);
        });
    }, [showActionSheetWithOptions]);
    return { showInteractionsSheet };
}
